export default __webpack_public_path__ + "static/week3-856342d1b5e03b06767ac40ddc40315b.png";